import React from 'react';
import {compose, lifecycle, pure} from 'recompose';
import {withRouter} from 'react-router-dom';
import {Formik} from 'formik';
import Title from '../../components/Title';
import Disclaimer from '../../components/Disclaimer';
import View from '../../components/View';
import {sendRecommendRequest} from "../../services/api";
import {metric} from '../../utils/metrics';
import {parseQueryString} from '../../utils/urlUtils';
import './styles.scss';

const RecommendView = (props) => {
  const queryParams = parseQueryString(props.location.search);
  return (
    <View title="Рекомендую Data Scientist" className="view--recommend">
      <Formik
        initialValues={{
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          refFirstName: queryParams.first_name || '',
          refLastName: queryParams.last_name || '',
          refEmail: queryParams.email || '',
          refComment: '',
          vacancyId: process.env.REACT_APP_RECOMMEND_VACANCY_ID,
          formToken: process.env.REACT_APP_LANDING_TOKEN,
          ref: process.env.REACT_APP_COMPANY_TOKEN,
        }}
        onSubmit={(values, {setSubmitting}) => {
          setSubmitting(true);
          sendRecommendRequest(values)
            .then((response) => {
              console.info(response);
              metric('reachGoal', 'click-recommend');
              props.history.push('/recommend/thankyou');
            })
            .catch((err) => {
              console.error(err);
              setSubmitting(false);
            });
        }}
        render={({ handleBlur, handleChange, handleSubmit, isSubmitting, initialValues }) => (
          <form method="get" className="form" onSubmit={handleSubmit}>
            <input name="ref" type="hidden" value={initialValues.ref} />
            <Title className="form__title">Ваши данные</Title>
            <div className="form__item">
              <input
                required={true}
                defaultValue={initialValues.firstName}
                name="firstName"
                type="text"
                className="input input--text"
                placeholder="Имя"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                required={true}
                defaultValue={initialValues.lastName}
                name="lastName"
                type="text"
                className="input input--text"
                placeholder="Фамилия"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                required={true}
                defaultValue={initialValues.phone}
                name="phone"
                type="tel"
                className="input input--text"
                placeholder="Номер телефона"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                required={true}
                defaultValue={initialValues.email}
                name="email"
                type="email"
                className="input input--text"
                placeholder="Электронная почта"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <Title className="form__title">Рекомендуемый</Title>
            <div className="form__item">
              <input
                name="refFirstName"
                required={true}
                defaultValue={initialValues.refFirstName}
                type="text"
                className="input input--text"
                placeholder="Имя"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                name="refLastName"
                required={true}
                defaultValue={initialValues.refLastName}
                type="text"
                className="input input--text"
                placeholder="Фамилия"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                name="refEmail"
                required={true}
                defaultValue={initialValues.refEmail}
                type="email"
                className="input input--text"
                placeholder="Электронная почта"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <textarea
                name="refComment"
                defaultValue={initialValues.refComment}
                rows={3}
                className="input input--textarea"
                placeholder="Комментарый (не обязательно)"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <button
                type="submit"
                className="button button--dark"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Отправка...' : 'Рекомендовать'}
              </button>
            </div>
            <div className="form__item">
              <Disclaimer label="Рекомендовать" />
            </div>
          </form>
        )}
      />
    </View>
  );
};

const enhance = compose(
  lifecycle({
    componentDidMount() {
      metric('hit', '/recommend');
    }
  }),
  withRouter,
  pure,
);

export default enhance(RecommendView);
